import React from 'react'
import './menu.scss'

import { Link } from "react-router-dom"

import dashboardIcon from '../../../assets/svg/dashboardIcon.svg'
import commentIcon from '../../../assets/svg/Comment.svg'
import compaignIcon from '../../../assets/svg/Compaign.svg'
import boxIcon from '../../../assets/svg/orderIcon.svg'
import reportIcon from '../../../assets/svg/Report.svg'
import offIcon from '../../../assets/svg/offIcon.svg'
import cashIcon from '../../../assets/svg/Cash.svg'
import smsIcon from '../../../assets/svg/Sms.svg'
import userIcon from '../../../assets/svg/userIcon.svg'
import exitIcon from '../../../assets/svg/exitIcon.svg'

export default function index({ page, badgeCountDashboard, badgeCountOrder }) {
  return (
    <aside id='aside'>
      <Link to='/dashboard' className='column'>
        <div className={page === 'dashboard' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='dashboardIcon' />
          <span>
            داشبورد اصلی
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        باشگاه مشتریان
        <hr style={{ width: '54%' }} />
      </div>
      {/* item */}
      <Link to='/customerClub' className='column'>
        <div className={page === 'dashboardCC' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='dashboardIcon' />
          <span>
            باشگاه مشتریان
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        مدیریت 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/cc/users' className='column'>
        <div className={page === 'user' ? 'row active' : 'row'}>
          <img src={userIcon} alt='userIcon' />
          <span>
            مشتریان و کاربران
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/cc/comments' className='column'>
        <div className={page === 'comments' ? 'row active' : 'row'}>
          <img src={commentIcon} alt='commentIcon' />
          <span>
            دیدگاه‌ها
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/cc/campaigns' className='column'>
        <div className={page === 'campaigns' ? 'row active' : 'row'}>
          <img src={compaignIcon} alt='compaignIcon' />
          <span>
            کمپین‌ها 
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/cc/orders' className='column'>
        <div className={page === 'orders' ? 'row active' : 'row'}>
          <img src={boxIcon} alt='' />
          <span>
            سفارش‌ها 
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        حسابداری 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/cc/reports' className='column'>
        <div className={page === 'reports' ? 'row active' : 'row'}>
          <img src={reportIcon} alt='reportIcon' />
          <span>
            گزارش‌ها 
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/cc/offs' className='column'>
        <div className={page === 'offs' ? 'row active' : 'row'}>
          <img src={offIcon} alt='offIcon' />
          <span>
            تخفیف‌ها 
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        تنظیمات 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/cc/cashback' className='column'>
        <div className={page === 'cashback' ? 'row active' : 'row'}>
          <img src={cashIcon} alt='cashIcon' />
          <span>
            کش بک 
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/cc/sendSms' className='column'>
        <div className={page === 'sms' ? 'row active' : 'row'}>
          <img src={smsIcon} alt='offIcosmsIconn' />
          <span>
            ارسال SMS 
          </span>
        </div>
      </Link>
      {/* supprot */}
      <Link href='##'>
        <div className='support'>
          <span>
            +
          </span>
          <span>
            تماس با پشتیبانی
          </span>
          <span>
            5719 3559 - 041   
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/' className='column'>
        <div className={page === 'exit' ? 'row active' : 'row'}>
          <img src={exitIcon} alt='' />
          <span>
            خروج
          </span>
        </div>
      </Link>
    </aside>
  )
}
